import { motion } from "framer-motion";
import { Phone } from "lucide-react";

export default function StickyPhoneBar() {
  return (
    <motion.a
      href="tel:+393517479343"
      data-testid="sticky-bottom-phone-bar"
      initial={{ y: 90 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.8, delay: 1.4, ease: [0.22, 1, 0.36, 1] }}
      className="md:hidden fixed bottom-4 left-4 right-4 z-50 flex items-center justify-center gap-3 bg-[#D97736] text-[#0B0C0E] font-outfit font-semibold rounded-full py-4 shadow-[0_12px_40px_rgba(217,119,54,0.35)]"
    >
      <span className="w-2 h-2 rounded-full bg-[#0B0C0E] animate-pulse-dot" aria-hidden="true" />
      <Phone size={17} />
      Chiama ora: +39 351 747 9343
    </motion.a>
  );
}
